import PropTypes from "prop-types";
import useMatchMedia from "../../../../useMatchMedia";
import HoverableProductImage from "../../../../__variants__/saved-lists-alternative-image-on-hover/shown/HoverableProductImage";
import ProductImage from "../../../../ProductImage";
import LazyProductHero from "../../../../LazyProductHero";
import ProductTileBanners from "../../../../ProductTileBanners";

const getImageComponent = ({ prefersReducedMotion, hasAdditionalImages }) => {
  if (prefersReducedMotion || !hasAdditionalImages) {
    return ProductImage;
  }

  return HoverableProductImage;
};

const ProductHero = ({ additionalImageUrls, ...rest }) => {
  const prefersReducedMotion = useMatchMedia("(prefers-reduced-motion)");
  const hasAdditionalImages = additionalImageUrls.length > 0;
  const ImageComponent = getImageComponent({
    prefersReducedMotion,
    hasAdditionalImages
  });

  return (
    <LazyProductHero
      {...{
        additionalImageUrls,
        render: lazyProps => (
          <ImageComponent {...{ additionalImageUrls, ...rest, ...lazyProps }} />
        ),
        ...rest
      }}
    >
      <ProductTileBanners {...rest} />
    </LazyProductHero>
  );
};

ProductHero.propTypes = {
  showVideo: PropTypes.bool,
  additionalImageUrls: PropTypes.arrayOf(PropTypes.string)
};

export default ProductHero;
